<template>
   <v-row dense>
      <v-col class="py-2">
         <v-card>
            <v-col class="d-flex align-center">
               <span class="subtitle-1">Клієнтів:</span>
               <v-spacer />
               <span class="title">{{ clientsCount }}</span>
            </v-col>
         </v-card>
      </v-col>
      <v-col class="py-2">
         <v-card>
            <v-col class="d-flex align-center">
               <span class="subtitle-1">Разом:</span>
               <v-spacer />
               <span class="title">
                  <ReportNumber :value="debtTotal" />
                  <span class="font-weight-medium body-1"> год</span>
               </span>
            </v-col>
         </v-card>
      </v-col>
   </v-row>
</template>

<script>
import ReportNumber from "../../../components/ReportNumber.vue";
export default {
  components: {
    ReportNumber,
  },
  props: ["source"],
  computed: {
    clientsCount() {
      return this.source.length;
    },

    debtTotal() {
      return this.source.reduce((sum, debt) => sum + debt.balance, 0);
    },
  },
};
</script>
